import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import fed from '../../Assets/Projects/face-mask-detection1.jpg';
import ped from "../../Assets/Projects/ped.png";
import rea from '../../Assets/Projects/react.png';
import genzfits from '../../Assets/Projects/genzfits.png'
import psf from '../../Assets/Projects/PSFoley.png'
import wds from '../../Assets/Projects/wds.png'
import naidu from '../../Assets/Projects/naidu.png'


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <p style={{ color: "white" }}>
          Note:- all projects are in my Google Drive, Soon I'll upload into github and I'll provide URLs
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={genzfits}
              isBlog={false}
              title="GenzFits - Fashion Ecommerce Platform"
              description=" 🎨 Passionate web designer skilled in crafting responsive, user-friendly websites using React.js, HTML, CSS, and JavaScript.
                            🚀 I specialize in building clean, modern UIs with a strong focus on performance, usability, and mobile-first design."
              
              ghLink="https://github.com/RajeshHarsha/GenZFits-E-commerce.git"
              
              demoLink = "https://genzfits.netlify.app/"
              
            />
          </Col> 

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={psf}
              isBlog={false}
              title="Author-P.S.foley"
              description="A marketing website for author P.S. Foley showcasing his novels, films, and spiritual travel journeys, with dedicated sections for featured books and author biography.​
Built as a storytelling-focused landing page that highlights each book’s theme and invites readers to explore and purchase through clear calls to action"
              ghLink="https://github.com/RajeshHarsha/PS-Foley.git"
              demoLink="https://author-psfoley.com/"
            />
          </Col>

          <Col md={4} className="project-card">
          <ProjectCard
          imgPath={wds}
          isBlog={false}
          title="Wonderland Sedona"
          description="A visually rich single‑page website presenting Wonderland Sedona, highlighting its brand, imagery, and key offerings for visitors in and around Sedona.​
Built as a static marketing site focused on clear sections (hero, about, services/gallery, contact) to quickly inform and convert visitors."
          ghLink="https://github.com/RajeshHarsha/wonderland-sedona.git"
          demoLink="https://wonderlandsedona.netlify.app/"
          />
          </Col>

          <Col md={4} className="project-card">
          <ProjectCard
          imgPath={naidu}
          isBlog={false}
          title="Naidu Constructions"
          description="A visually rich single‑page website presenting Wonderland Sedona, highlighting its brand, imagery, and key offerings for visitors in and around Sedona.​
Built as a static marketing site focused on clear sections (hero, about, services/gallery, contact) to quickly inform and convert visitors."
          ghLink="https://github.com/RajeshHarsha/wonderland-sedona.git"
          demoLink="https://naiduconstructions.netlify.app/"
          />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ped}
              isBlog={false}
              title="Phishing Email Detaction"
              description="Phishing emails scans the email and detacts the URLs whether the attached URL is legitimate or not and also clasify the URLs "
               ghLink="https://github.com/RajeshHarsha/Phishing-Email-Detection-Using-RCNN-algorithma.git"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              // imgPath={fsd}
              imgPath={fed}
              isBlog={false}
              title="Face Mask Detection"
              description="Trained a CNN classifier usingdataset with Keras and tensorflow backened. The classifier sucessfully detects the face mask of humans. And the highest accuracy obtained with the model was 93.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/RajeshHarsha/FaceMaskDetection.git"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rea}
              isBlog={false}
              title="My Portfolio"
              description="Designed and built this website to showcase my web design skills and user-centered approach. Includes clear project descriptions and is fully responsive."
              ghLink="https://github.com/RajeshHarsha/rajportfolio.git"
              demoLink="https://rajeshrouthuportfolio.netlify.app/"
            
            />
          </Col>
          
          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
